import { render, staticRenderFns } from "./InfoStoringAnswer.vue?vue&type=template&id=d3a54f9a"
import script from "./InfoStoringAnswer.vue?vue&type=script&lang=js"
export * from "./InfoStoringAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports